import {
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import react, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { TextField } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2";
import { addCommas, removeCommas } from "@persian-tools/persian-tools";
import axios from "axios";
import jMoment from "moment-jalaali";
import { useSnackbar } from "notistack";
import React from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { font as shabnamFontBinary } from "../../shared/util/functions";

const columns = [
	{ label: "نام پزشک", key: "doctorName", alignment: "center" },
	{ label: "نام بیمار", key: "patientName", alignment: "center" },
	{ label: "نوع کار", key: "workType", alignment: "center" },
	{ label: "تعداد واحد", key: "unitCount", alignment: "center" },
	{ label: "قیمت هر واحد", key: "unitCost", alignment: "center" },
	{ label: "مبلغ سفارش", key: "totalCost", alignment: "center" },
	{ label: "مبلغ پس از تخفیف", key: "afterDiscount", alignment: "center" },
];

const style = {
	position: "absolute",
	top: "50%",
	left: "50%",
	transform: "translate(-50%, -50%)",
	maxWidth: 400,
	width: "90%",
	bgcolor: "background.paper",
	border: "2px solid #000",
	boxShadow: 24,
	p: 4,
	mx: "auto",
};

const ReceiptDetails = () => {
	const auth = useContext(AuthContext);
	const { enqueueSnackbar } = useSnackbar();
	const navigate = useNavigate();
	const routeState = useSelector((state) => state.routeReducer);

	const [receiptInfo, setReceiptInfo] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const receiptId = useParams().rId;
	const [open, setOpen] = useState(false);
	const handleOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};
	const handleDelete = async () => {
		setIsLoading(true);
		await axios
			.delete("/api/v1/laboratorys/delete-receipts", {
				data: {
					receiptId: Number(receiptId),
				},

				headers: {
					authorization: auth.token,
				},
			})
			.then((response) => {
				enqueueSnackbar(response.data.message.message, {
					variant: "success",
				});
				handleClose();
			})
			.catch((e) => {
				const messages = e.response.data.data;
				Array.isArray(messages)
					? messages.map((message) => {
							enqueueSnackbar(message, { variant: "error" });
					  })
					: enqueueSnackbar(messages, { variant: "error" });
			})
			.finally(() => {
				setIsLoading(false);
			});
		navigate("/lab/receipts/view");
	};

	const handleToggleIsPayed = async () => {
		await axios
			.post(
				"/api/v1/laboratorys/update-receipt-payment",
				{
					receiptId: parseInt(receiptId),
					status: !receiptInfo.isPayed,
				},
				{ headers: { Authorization: auth.token } }
			)
			.then(async (res) => {
				enqueueSnackbar(res.data.message.message, {
					variant: "success",
				});
				await getReceiptInfo();
			})
			.catch(
				(err) =>
					err.data &&
					err.data.map((error) => {
						enqueueSnackbar(error, { variant: "error" });
					})
			);
	};

	const handlePDFDocCreation = () => {
		const rightMargin = 13.2;
		const leftMargin = 19;
		const topMargin = 25.4;
		const bottomMargin = 36.7;
		const paperWidth = 297;
		const paperHeight = 210;
		const spaceBetweenLines = 15;
		let lastY = topMargin;
		const defaultTextOptions = {
			align: "right",
			maxWidth: paperWidth,
			isSymmetricSwapping: true,
			isInputVisual: true,
			isOutputVisual: false,
		};

		const texts = [
			{
				fontSize: 24,
				text: "اطلاعات فاکتور",
				textOptions: defaultTextOptions,
			},
			{
				fontSize: 24,
				text: "جزئیات ",
				textOptions: defaultTextOptions,
			},
			{
				fontSize: 24,
				text: "مجموع",
				textOptions: defaultTextOptions,
			},
		];

		jsPDF.autoTableSetDefaults({
			headStyles: { fillColor: 0 },
		});
		const doc = new jsPDF({ orientation: "l", unit: "mm" });
		doc.setFont("Shabnam-FD");
		doc.setFontSize(texts[0].fontSize);
		doc.text(
			texts[0].text,
			paperWidth - rightMargin,
			lastY,
			texts[0].textOptions
		);
		lastY += spaceBetweenLines;

		autoTable(doc, {
			head: [["ارسال شده برای", "به نام", "تاریخ صدور", "شناسه فاکتور"]],
			headStyles: {
				fontStyle: "bold",
				font: "Shabnam-FD",
				halign: "center",
				fillColor: "#000",
			},
			startY: lastY,
			theme: "striped",
			styles: {
				font: "Shabnam-FD",
				halign: "center",
				valign: "middle",
				fontSize: 12,
				lineWidth: 1,
			},
			body: [
				[
					receiptInfo.doctor.name,
					receiptInfo.name,
					jMoment(parseInt(receiptInfo.submissionDate)).format(
						"jYYYY/jMM/jDD - hh:mm:ss"
					),
					receiptInfo.id,
				],
			],
			alternateRowStyles: {
				// fillColor: 'whitesmoke',
			},
			bodyStyles: {
				minCellHeight: 10,
			},
		});

		lastY = doc.lastAutoTable.finalY + spaceBetweenLines + 5;
		doc.setFontSize(texts[1].fontSize);
		doc.text(
			texts[1].text,
			paperWidth - rightMargin,
			lastY,
			texts[1].textOptions
		);
		lastY += spaceBetweenLines;

		autoTable(doc, {
			head: [columns.reverse().map((col) => col.label)],
			headStyles: {
				fontStyle: "bold",
				font: "Shabnam-FD",
				halign: "center",
				fillColor: "#000",
			},
			startY: lastY,
			theme: "striped",
			styles: {
				font: "Shabnam-FD",
				halign: "center",
				valign: "middle",
				fontSize: 12,
				lineWidth: 1,
			},
			body: receiptInfo.orders.map((row) => {
				return [
					row.doctorName,
					row.patientName,
					row.orderTypeName,
					row.unitCount,
					addCommas(row.unitCost),
					addCommas(row.totalCost),
					addCommas(row.afterDiscount),
				].reverse();
			}),
			alternateRowStyles: {
				// fillColor: 'whitesmoke',
			},
			bodyStyles: {
				minCellHeight: 10,
			},
		});
		lastY = doc.lastAutoTable.finalY + spaceBetweenLines + 5;
		doc.setFontSize(texts[2].fontSize);
		doc.text(
			texts[2].text,
			paperWidth - rightMargin,
			lastY,
			texts[2].textOptions
		);
		lastY += spaceBetweenLines;

		autoTable(doc, {
			head: [["مبلغ پس از تخفیف", "مبلغ سفارش"]],
			headStyles: {
				fontStyle: "bold",
				font: "Shabnam-FD",
				halign: "center",
				fillColor: "#000",
			},
			startY: lastY,
			theme: "striped",
			styles: {
				font: "Shabnam-FD",
				halign: "center",
				valign: "middle",
				fontSize: 12,
				lineWidth: 1,
			},
			body: [
				[
					addCommas(
						receiptInfo.orders.reduce(
							(accumulator, currentValue) => {
								return accumulator + currentValue.totalCost;
							},
							0
						)
					),
					addCommas(
						receiptInfo.orders.reduce(
							(accumulator, currentValue) => {
								return (
									parseInt(currentValue.afterDiscount) +
									accumulator
								);
							},
							0
						)
					),
				],
			],
			alternateRowStyles: {
				// fillColor: 'whitesmoke',
			},
			bodyStyles: {
				minCellHeight: 10,
			},
		});

		return doc;
	};

	const handlePDFDownload = (doc, _fileName) => {
		const d = new Date();
		doc.save(
			_fileName
				? _fileName
				: `receipt-detail-id-${receiptId}-${d.getFullYear()}-${d.getMonth()}-${d.getDate()}-${d.getHours()}-${d.getMinutes()}-${d.getSeconds()}`
		);
	};

	const getReceiptInfo = async () => {
		await axios
			.post(
				"/api/v1/laboratorys/get-receipt-details",
				{ receiptId },
				{ headers: { Authorization: auth.token } }
			)
			.then((res) => setReceiptInfo(res.data.data))
			.catch(
				(err) =>
					err.data &&
					err.data.map((error) => {
						enqueueSnackbar(error, { variant: "error" });
					})
			);
		setIsLoading(false);
	};

	useEffect(() => {
		getReceiptInfo();
	}, [receiptId]);

	const prevRoute = useSelector((state) => state.routeReducer.prevRoute);

	if (isLoading) {
		return (
			<div className="center">
				<h2>در حال بارگذاری...</h2>
			</div>
		);
	}
	return (
		<react.Fragment>
			<Paper sx={{ maxWidth: 1200 }}>
				<div>
					<Modal open={open} onClose={handleClose}>
						<Box sx={style}>
							<Typography variant="h6" component="h2">
								هشدار
							</Typography>
							<Typography
								id="modal-modal-description"
								sx={{ mt: 2 }}
							>
								آیا مطمئنید می خواهید این فاکتور را حذف کنید ؟
							</Typography>
							<Grid container spacing={3} sx={{ mt: 2 }}>
								<Grid xs={6}>
									<Button
										fullWidth
										color="error"
										variant="contained"
										onClick={handleDelete}
									>
										بله
									</Button>
								</Grid>
								<Grid xs={6}>
									<Button
										fullWidth
										color="primary"
										variant="contained"
										onClick={handleClose}
									>
										خیر
									</Button>
								</Grid>
							</Grid>
						</Box>
					</Modal>
				</div>

				<Grid
					container
					spacing={3}
					sx={{
						p: 2,
						m: 1,
						mb: 5,
					}}
				>
					<Grid
						md={6}
						xs={12}
						display={"flex"}
						justifyContent={{ sm: "flex-start", xs: "center" }}
					>
						<Typography variant="h5" align="center">
							اطلاعات فاکتور
						</Typography>
					</Grid>
					<Grid
						sm={6}
						xs={12}
						display={"flex"}
						justifyContent={{ sm: "flex-end", xs: "center" }}
					>
						<Button
							color={receiptInfo.isPayed ? "success" : "error"}
							variant="contained"
							size="large"
							onClick={handleToggleIsPayed}
						>
							{receiptInfo.isPayed ? "پرداخت شده" : "پرداخت نشده"}
						</Button>
					</Grid>
					<Grid md={6} xs={12}>
						<TextField
							variant="standard"
							label="شماره فاکتور"
							value={receiptInfo.receiptCode}
							inputProps={{ readOnly: true }}
							fullWidth
						/>
					</Grid>
					<Grid md={6} xs={12}>
						<TextField
							variant="standard"
							label="تاریخ صدور"
							value={jMoment(
								parseInt(receiptInfo.submissionDate)
							).format("jYYYY/jMM/jDD")}
							inputProps={{ readOnly: true }}
							fullWidth
						/>
					</Grid>
					<Grid md={6} xs={12}>
						<TextField
							variant="standard"
							label="به نام"
							value={receiptInfo.name}
							inputProps={{ readOnly: true }}
							fullWidth
						/>
					</Grid>
					<Grid md={6} xs={12}>
						<TextField
							variant="standard"
							label="ارسال شده برای"
							value={receiptInfo.doctor.name}
							inputProps={{ readOnly: true }}
							fullWidth
						/>
					</Grid>
					<Grid xs={12}>
						<TableContainer
							component={Paper}
							aria-label="simple table"
						>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell align="justify">
											نام پزشک
										</TableCell>
										<TableCell align="justify">
											نام بیمار
										</TableCell>
										<TableCell align="justify">
											نوع کار
										</TableCell>
										<TableCell align="justify">
											تعداد واحد
										</TableCell>
										<TableCell align="justify">
											قیمت هر واحد
										</TableCell>
										<TableCell align="justify">
											مبلغ سفارش
										</TableCell>
										<TableCell align="justify">
											مبلغ پس از تخفیف
										</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
									{receiptInfo.orders.map((receipt) => (
										<react.Fragment>
											<TableRow>
												<TableCell align="justify">
													{receipt.doctorName}
												</TableCell>
												<TableCell align="justify">
													{receipt.patientName}
												</TableCell>
												<TableCell align="justify">
													{receipt.orderTypeName}
												</TableCell>
												<TableCell align="justify">
													{receipt.unitCount}
												</TableCell>
												<TableCell align="justify">
													{isNaN(
														removeCommas(
															addCommas(
																receipt.unitCost
															)
														)
													)
														? receipt.unitCost
														: addCommas(
																receipt.unitCost
														  )}
												</TableCell>
												<TableCell align="justify">
													{isNaN(
														removeCommas(
															addCommas(
																receipt.totalCost
															)
														)
													)
														? receipt.totalCost
														: addCommas(
																receipt.totalCost
														  )}
												</TableCell>
												<TableCell align="justify">
													{isNaN(
														removeCommas(
															addCommas(
																receipt.afterDiscount
															)
														)
													)
														? receipt.afterDiscount
														: addCommas(
																receipt.afterDiscount
														  )}
												</TableCell>
											</TableRow>
											{receipt.attachments.map(
												(attachment) => (
													<TableRow>
														<TableCell>
															<Chip
																label="پیوست"
																color="primary"
																size="small"
															/>
														</TableCell>
														<TableCell children="---" />
														<TableCell align="justify">
															{attachment.title}
														</TableCell>
														<TableCell align="justify">
															{attachment.count}
														</TableCell>
														<TableCell children="---" />
														<TableCell align="justify">
															{isNaN(
																removeCommas(
																	addCommas(
																		attachment.totalPrice
																	)
																)
															)
																? attachment.totalPrice
																: addCommas(
																		attachment.totalPrice
																  )}
														</TableCell>
														<TableCell align="justify">
															{isNaN(
																removeCommas(
																	addCommas(
																		attachment.afterDiscount
																	)
																)
															)
																? attachment.afterDiscount
																: addCommas(
																		attachment.afterDiscount
																  )}
														</TableCell>
													</TableRow>
												)
											)}
										</react.Fragment>
									))}
								</TableBody>
							</Table>
						</TableContainer>
					</Grid>
					<Grid xs={12} md={4}>
						<Button
							fullWidth
							color="error"
							variant="outlined"
							onClick={handleOpen}
						>
							<DeleteIcon />
							حذف فاکتور
						</Button>
					</Grid>
					<Grid xs={12} md={4}>
						<Button
							fullWidth
							color="secondary"
							variant="contained"
							onClick={() =>
								handlePDFDownload(handlePDFDocCreation())
							}
						>
							<FileDownloadIcon />
							دانلود به صورت پی‌دی‌اف
						</Button>
					</Grid>
					<Grid xs={12} md={4}>
						<Link
							to={prevRoute}
							style={{
								color: "inherit",
								textDecoration: "inherit",
							}}
						>
							<Button
								fullWidth
								color="primary"
								variant="contained"
								disabled={routeState.prevRoute.length === 0}
								onClick={() => {
									navigate(routeState.prevRoute);
								}}
							>
								<ArrowBackIcon />
								بازگشت به صفحه فاکتورها
							</Button>
						</Link>
					</Grid>
				</Grid>
			</Paper>
		</react.Fragment>
	);
};

export default ReceiptDetails;

//add font to jspdf class

const font = shabnamFontBinary;

var callAddFont = function () {
	this.addFileToVFS("Shabnam-FD-normal.ttf", font);
	this.addFont("Shabnam-FD-normal.ttf", "Shabnam-FD", "normal");
};
jsPDF.API.events.push(["addFonts", callAddFont]);
